<template>
    <GdprUpdateContainer
        :isInModal="true"
        @savedSuccess="onSuccesfulSave"
        @cancel="onCancel"
    />
</template>

<script>
    import { mapActions } from 'vuex';
    import GdprUpdateContainer from '@modules/userProfile/gdpr/GdprUpdateContainer';
    import { routeNames } from '@app/router';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'ChooseGdprModal',
        data() {
            return {
                isSuccess: false
            };
        },
        methods: {
            ...mapActions('data/authentication', [
                'logout',
            ]),
            ...mapActions('ui/user/messages', [
                'showBonusMessages',
            ]),
            onSuccesfulSave() {
                this.isSuccess = true;
                this.$emit('close');
            },
            onCancel() {
                this.$emit('close');
            }
        },
        destroyed() {
            if (this.isSuccess) {
                errorGuard({
                    action: () => this.showBonusMessages()
                });
            } else {
                this.$router.push({ name: routeNames.landing });
                errorGuard({
                    action: () => this.logout()
                });
            }
        },
        components: {
            GdprUpdateContainer,
        }
    };
</script>

<style>
    .gdpr_modal {
        width: 800px;
        max-width: 800px;
        max-height: 1400px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/ChooseGdprModal.vue